// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3ofjd","amount":"Amount_amount__3ILCg","tip":"Amount_tip__2X-va","tipHeader":"Amount_tipHeader__3BlEK","tipsWrap":"Amount_tipsWrap__1b8Zc"};